/**
 * @generated SignedSource<<afd18f2c21929ca4400238a51845d8b8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type HomeSidebarNavigation_currentItemQuery$variables = {
  cloudId?: string | null;
  tagUuid: string;
  teamId: string;
  viewUuid: string;
  workspaceUuid: string;
};
export type HomeSidebarNavigation_currentItemQuery$data = {
  readonly tagByUuid: {
    readonly name: string | null;
    readonly uuid: string | null;
  } | null;
  readonly teamByTeamId: {
    readonly name: string | null;
    readonly teamId: string | null;
  } | null;
  readonly view: {
    readonly name: string | null;
    readonly uuid: string | null;
  } | null;
};
export type HomeSidebarNavigation_currentItemQuery = {
  response: HomeSidebarNavigation_currentItemQuery$data;
  variables: HomeSidebarNavigation_currentItemQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tagUuid"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewUuid"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceUuid"
},
v5 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "teamId",
    "variableName": "teamId"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "name"
},
v7 = {
  "kind": "ScalarField",
  "name": "teamId"
},
v8 = [
  {
    "kind": "Variable",
    "name": "uuid",
    "variableName": "tagUuid"
  }
],
v9 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v10 = [
  {
    "kind": "Variable",
    "name": "uuid",
    "variableName": "viewUuid"
  },
  {
    "kind": "Variable",
    "name": "workspaceUuid",
    "variableName": "workspaceUuid"
  }
],
v11 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "HomeSidebarNavigation_currentItemQuery",
    "selections": [
      {
        "args": (v5/*: any*/),
        "concreteType": "Team",
        "kind": "LinkedField",
        "name": "teamByTeamId",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/)
        ]
      },
      {
        "args": (v8/*: any*/),
        "concreteType": "Tag",
        "kind": "LinkedField",
        "name": "tagByUuid",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v9/*: any*/)
        ]
      },
      {
        "alias": "view",
        "args": (v10/*: any*/),
        "concreteType": "DirectoryView",
        "kind": "LinkedField",
        "name": "directoryViewByUuid",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          (v6/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "HomeSidebarNavigation_currentItemQuery",
    "selections": [
      {
        "args": (v5/*: any*/),
        "concreteType": "Team",
        "kind": "LinkedField",
        "name": "teamByTeamId",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/),
          (v11/*: any*/)
        ]
      },
      {
        "args": (v8/*: any*/),
        "concreteType": "Tag",
        "kind": "LinkedField",
        "name": "tagByUuid",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v9/*: any*/),
          (v11/*: any*/)
        ]
      },
      {
        "alias": "view",
        "args": (v10/*: any*/),
        "concreteType": "DirectoryView",
        "kind": "LinkedField",
        "name": "directoryViewByUuid",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          (v6/*: any*/),
          (v11/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "85850d2009ca5f48ac92b4c701ffe14e",
    "id": null,
    "metadata": {},
    "name": "HomeSidebarNavigation_currentItemQuery",
    "operationKind": "query",
    "text": "query HomeSidebarNavigation_currentItemQuery(\n  $teamId: String!\n  $tagUuid: UUID!\n  $viewUuid: UUID!\n  $workspaceUuid: UUID!\n  $cloudId: String\n) {\n  teamByTeamId(teamId: $teamId, cloudId: $cloudId) {\n    name\n    teamId\n    id\n  }\n  tagByUuid(uuid: $tagUuid) {\n    name\n    uuid\n    id\n  }\n  view: directoryViewByUuid(workspaceUuid: $workspaceUuid, uuid: $viewUuid) {\n    uuid\n    name\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d4510339232f5ce392d26169be5a5e95";

export default node;
